module.exports = __webpack_public_path__ + "static/media/estoril.ee6a810e.webp";